// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Conditions_cardWrapper__3kiHy","removeButton":"Conditions_removeButton__1jiaY"};